import { z } from 'zod';

export const deleteVideoSchema = z.object({
  video_id: z.uuid('Invalid video ID'),
});

export type DeleteVideoPayload = z.infer<typeof deleteVideoSchema>;
